import { ReactNode, useCallback, useMemo, useState } from 'react'

import {
  OverlayError,
  ParameterOverlayErrorContext
} from '../parameterOverlayErrorContext'

export const ErrorContextWrapper = ({ children }: { children: ReactNode }) => {
  const [errors, setErrors] = useState<OverlayError[]>([])

  const clearError = useCallback(
    () => (id: string) => errors.filter((error) => error.id === id),
    [errors]
  )

  const value = useMemo(
    () => ({ errors, setErrors, clearError }),
    [clearError, errors]
  )

  return (
    <ParameterOverlayErrorContext.Provider value={value}>
      {children}
    </ParameterOverlayErrorContext.Provider>
  )
}
